import VenuesMapDisplay from './VenuesMapDisplay';

export default VenuesMapDisplay;
